import { type ReactNode, useSyncExternalStore } from 'react';

function subscribe(callback: () => void): () => void {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

/** Aviso persistente quando o navegador está sem conexão. */
export function OfflineBanner(): ReactNode {
  const online = useSyncExternalStore(subscribe, () => navigator.onLine);
  if (online) return null;
  return (
    <div role="status" className="bg-warning px-4 py-2 text-center text-sm text-warning-foreground">
      Você está sem conexão. Algumas ações podem falhar até a conexão voltar.
    </div>
  );
}
